<template>
    <transition  >
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Dental </li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Contract Patients</a></li>
                            
                        </ol>
                    </div>
                    <div class="page-title-right float-right "> 
                        <!-- <button type="button" class="btn btn-primary float-right" @click="toggleImportModal">
                            <i class="fas fa-plus"></i> Bulk Adjustment
                        </button>  -->
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-header">
                        <div class="row" >
                            <div class="col-md-2">
                                <div class="">
                                    <label for="category_id"> Patient *</label>
                                    <select class="form-control" id="category_id" v-model="tableData.patient_id" @change="onChangePatient($event.target.value)">
                                        <option value="">--- Select Patient ---</option>
                                        <option v-for="(patient, i) in patients" :key="i" :value="patient.id">{{ patient.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="">
                                    <label for="sub_category_id"> Service *</label>
                                    <select class="form-control" id="sub_category_id" v-model="tableData.service_id">
                                        <option value="">--- Select Service ---</option>
                                        <option v-for="(service, i) in patient_services" :key="i" :value="service.id">{{ service.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="">
                                    <label for="service_status"> Status *</label>
                                    <select class="form-control" id="service_status" v-model="tableData.service_status">
                                        <option value="">--- Select Status ---</option>
                                        <option value="1">Running</option>
                                        <option value="2">Complete</option>
                                        <option value="3">Stopped</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="">
                                    <label for="from_date"> From Date *</label>
                                    <input type="date" class="form-control" id="start_date" v-model="tableData.start_date">
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="">
                                    <label for="to_date"> To Date *</label>
                                    <input type="date" class="form-control" id="end_date" v-model="tableData.end_date">
                                </div>
                            </div>

                            <div class="col-md-2" style="padding-right: 0 !important; text-align: right;">
                                <div class="mt-3">
                                    <button type="submit" class="btn btn-primary" :disabled="disabled" @click="fetchItems(), disabled=true, isSubmit=true">
                                        <span v-show="isSubmit">
                                            <i class="fas fa-spinner fa-spin" ></i>
                                        </span>Filter 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <Datatable 
                            :columns="columns" 
                            :sortKey="tableData.sortKey"  
                            @sort="sortBy" 
                            v-if="!loading">
                            <template #header > 
                                <div class="tableFilters" style="margin-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="control" style="float: left;">
                                                <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                <div class="select" style="float: left;">
                                                    <select class="form-select" v-model="tableData.length" @change="fetchItems()"> 
                                                        <option value="10" selected="selected">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="100">200</option>
                                                        <option :value="pagination.total">All</option>
                                                    </select>
                                                </div>
                                                <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-2">
                                             
                                        </div>
                                        <div class="col-md-4">
                                            <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="fetchItems()">
                                        </div>
                                    </div>
                                </div>   
                            </template> 
                            <template #body >  
                                <tbody v-if="items.length > 0">
                                    <tr class="border" v-for="(item, i) in items" :key="i">
                                        <td>{{ i + 1 }} </td>
                                        <td>{{ item.patient_name }} </td> 
                                        <td>{{ item.service_name }} </td> 
                                        <td>{{ item.service_start_date }} </td>
                                        <td>{{ item.last_service_date }}</td>
                                        <td class="text-right">{{ item.contract_amount }} </td> 
                                        <td class="text-right">{{ item.paid_amount }} </td>
                                        <td class="text-right">{{ item.due_amount }} </td>
                                        <td>
                                            <div class="dropdown float-end">
                                                <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <!-- item-->
                                                    <a href="#" @click="paymentDetails(item)" class="dropdown-item text-info"><i class="fa-solid fa-currncy"></i> Payment Details</a> 
                                                    <!-- <a href="javascript:void(0);" class="dropdown-item text-primary" @click="adjustProductStock(item)" title="Adjust Stock">
                                                        <i class="mdi mdi-plus-outline me-1"></i>Adjustment
                                                    </a> -->
                                                    <!-- item-->
                                                </div>
                                            </div>   
                                        </td>
                                    </tr> 
                                </tbody> 
                                <tbody v-else>
                                    <tr>
                                        <td colspan="5"> No Data Available Here!</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="5" class="text-center"> Total </th>
                                        <th class="text-right">{{ totalAmount('contract_amount') }}</th>
                                        <th class="text-right">{{ totalAmount('paid_amount') }}</th>
                                        <th class="text-right">{{ totalAmount('due_amount') }}</th>
                                        <th></th>
                                    </tr>
                                </tfoot>
                            </template> 
                            <template #footer>
                                <Pagination 
                                    :pagination="pagination"  
                                    :language="lang"
                                    @onChangePage="setPage" > 
                                </Pagination> 
                            </template> 
                        </Datatable> 

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>

                    </div> 
                </div>
            </div>
        </div>

        
        <!-- Payment Details Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin">
                <div class="modal-header"> 
                    <button @click="toggleModal()" type="button" class="btn btn-danger"><i class="fa fa-times"></i></button>
                    <h5 style="text-align: right;">Payment Details</h5>
                </div>
                <div class="modal-body">
                    <!-- <h4 style="margin-bottom: 16px;">Payment Details</h4> -->
                    <table class="table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th>Payment Date</th>
                                <th>Bill No</th>
                                <th>Payment Type</th>
                                <th>Visit Fee</th>
                                <th>Service Amount</th>
                                <th>Discount</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(payment, index) in payment_details" :key="index">
                                <td>{{ payment.payment_date }}</td>
                                <td>{{ payment.dental_billing.bill_no }}</td>
                                <td>{{ payment.payment_type }}</td>
                                <td class="text-end">{{ payment.dental_billing.visit_amount }}</td>
                                <td class="text-end">{{ payment.dental_billing.service_amount }}</td>
                                <td class="text-end">{{ payment.dental_billing.discount }}</td>
                                <td class="text-end">{{ payment.amount }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="3" class="text-end">Total</th>
                                <th class="text-end"></th>
                                <th class="text-end"></th>
                                <th class="text-end"></th>
                                <th class="text-end">{{ payment_details.reduce((sum, p) => sum + Number(p.amount || 0), 0).toFixed(2) }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="modal-footer"> 
                    <button @click="toggleModal()" type="button" class="btn btn-danger">Close</button>
                    <!-- <button type="submit" class="btn btn-primary " :disabled="disabled">
                        <span v-show="isSubmit">
                            <i class="fas fa-spinner fa-spin" ></i>
                        </span> Submit 
                    </button> -->
                    
                </div>
            </div>
        </Modal>
    </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "./../../helper/Modal";
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        Datatable,
        Pagination
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            importModal: false,
            errors: {},
            items: [],
            patients: [],
            services: [],
            patient_services: [],
            payment_details: [],
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id+'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },

            adjustObj: new Form({
                cost_center_id: null,
                stock_id: '',
                unit_code: '',
                in_stock_quantity: '',
                out_stock_quantity: '',
                remarks: '',
            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
            renderOptionComponent: true,
            columns: [ 
                {
                    label: 'SL',
                    name: '',           
                    width: '5%'
                },   
                {
                    label: 'Patient Name',
                    name: 'patient_name',
                    width: '15%'
                },
                {
                    label: 'Service Name',
                    name: 'service_name',
                    width: '10%'
                },  
                {
                    label: 'Start Date',
                    name: 'service_start_date',
                    width: '10%'
                },
                {
                    label: 'Last Service Date',
                    name: 'last_service_date',
                    width: '10%'
                },
                {
                    label: 'Contract Amount',
                    name: 'contract_amount',
                    width: '10%'
                },
                {
                    label: 'Paid Amount',
                    name: 'paid_amount',
                    width: '10%'
                },
                {
                    label: 'Due Amount',
                    name: 'due_amount',
                    width: '10%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 1,
                dir: 'desc',
                sortKey: 'patient_name', 
                patient_id: '',
                service_id: '',
                service_status: 1,
                start_date: '',
                end_date: '',

            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() {
        // this.fetchCostCenters();
        this.fetchDentalPatient();
        this.fetchDetalServices();
        this.fetchItems();
    },
    methods: { 
        toggleModal: function() {
            this.modalActive = !this.modalActive;
            if(!this.modalActive) {
                this.payment_details = [];
            }
        },

        totalAmount(type="") {
            var qsum = 0;
            this.items.filter((item) => {
                if(type=="contract_amount") {
                    qsum += parseFloat(item.contract_amount);
                }else if(type=="paid_amount") {
                    qsum += parseFloat(item.paid_amount);
                }else if(type=="due_amount") {
                    qsum += parseFloat(item.due_amount);
                }else{
                    qsum += parseFloat(0);
                }
            });
            return qsum;
        },

        // Cost Center Data
        fetchDentalPatient()
        {
            axios.get(this.apiUrl+'/hm/dental_patients/list', this.headerjson)
            .then((res) => {
                this.patients = res.data.data;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        fetchDetalServices() {
            axios.get(this.apiUrl+"/hm/dental_services/list", this.headerjson)
            .then((resp) => {
                this.services = resp.data.data;
                this.patient_services = resp.data.data;
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
        }, 

        onChangePatient: function(patient_id) {
            this.patient_services = [];
            this.tableData.service_id = '';
            if(patient_id != "") {
                let service_ids = this.patients.find(p => p.id == patient_id).service_ids;
                if(service_ids && service_ids.length > 0) {
                    this.patient_services = this.services.filter(s => service_ids.includes(s.id));
                }
            } 
        },

        paymentDetails: function(item) {
            axios.get(this.apiUrl+"/hm/dental_patient_payment_by_contracts?patient_id="+item.patient_id+"&contract_id="+item.id, this.headerjson)
            .then((res) => {
                this.payment_details = res.data.data;
                this.toggleModal();
            })
            .catch(errors => {
                console.log(errors);
            })
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
            
        // datatable For Pagination 
        fetchItems(url = this.apiUrl+'/hm/dental_patient_contracts') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                this.isSubmit = false;
                this.disabled = false;
                let data = response.data.data.data; 
                this.items = data.data;
                this.configPagination(data);
            })
            .catch(errors => {
                console.log(errors);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.fetchItems();
        },
        setPage(data){  
            this.fetchItems(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        }
        // datatable For Pagination 

    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        
    }
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.total_quantity {
    float: right;
    color: red;
}
.approve_total_quantity {
    float: right;
    color: red;
    margin-right: 10px;
}

.product_table {
    padding: 0;
    min-height: auto;
}

.product_table tbody td input {
    border-bottom: 1px solid #cecece;
}

.actions {
    
}

.actions a{
    margin-right: 5px;
}
</style>